export enum SeverityEnum {
  Debug = 0,
  Info = 1,
  Warn = 2,
  Error = 3,
  Alert = 4,
  Critical = 5,
  Emergency = 6,
}
